import { defineStore, storeToRefs } from "pinia";
import { computed, ref } from "vue";
import useCotizacionEstandarDatosStore from "@/store/cotizaciones/estandar/datos";
import useCotizacionEstandarLeaseParametersStore from "@/store/cotizaciones/estandar/lease-parameters";
import useCotizacionEstandarSourcesStore from "@/store/cotizaciones/estandar/sources";
import { useCotizacionEstandarStore } from "@/store/cotizaciones/estandar/";

const useCotizacionEstandarKeyMetricsStore = defineStore(
  "cotEstKeyMetrics",
  () => {
    const { calculaPmt } = useCotizacionEstandarDatosStore();

    const { stateCalculosLeaseParameters } = storeToRefs(
      useCotizacionEstandarStore()
    );

    const { leaseParameters } = storeToRefs(
      useCotizacionEstandarLeaseParametersStore()
    );

    const keyMetrics = computed(() => {
      const facilityDrawEquip = ref(undefined); // TODO: Pendiente
      const facilityDrawEquipVAT = ref(undefined); // TODO: Pendiente
      const irrGross = ref(undefined); // TODO: Pendiente (=-D55+E60+E70+E65)
      const leasePrincipalAmount = ref(
        leaseParameters.value.equipmentValueBeforeDes.value -
          leaseParameters.value.downPaymentMonto.value
      );

      const monthlyPayment = ref(
        -calculaPmt(
          leaseParameters.value.coupon.value / 12 / 100,
          leaseParameters.value.duration.value -
            stateCalculosLeaseParameters.value.gracePeriodMonths,
          leasePrincipalAmount.value,
          -leaseParameters.value.rvMonto.value
        )
      );

      return {
        leasePrincipalAmount,
        monthlyPayment,
      };
    });

    return {
      keyMetrics,
    };
  }
);

export default useCotizacionEstandarKeyMetricsStore;
